<template>
  <div class="vx-card p-6">
    <h1 class=" text-center mb-5">
      ÜRETİM SÜRECİ
    </h1>
    <form-wizard color="rgba(var(--vs-primary), 1)" finishButtonText="Kaydet" backButtonText="Geri" nextButtonText="İleri" ref="formWizard" stepSize="xs" shape="tab" @on-complete="formSubmitted" @on-change="formWizardPageChanged">
      <!--***************************************** tab 1 content****************************************************** -->
      <tab-content title="Üretimi Yapılacak Ürün" class="mb-5" icon="feather icon-codepen" :before-change="validateAsync" lazy="true">
        <ag-grid-vue
          style="height: 60vh;"
          ref="agGridTable"
          class="ag-theme-material ag-grid-table"
          rowSelection="single"
          rowMultiSelectWithClick="true"
          :localeText="localeText"
          :gridOptions="gridOptions"
          :getRowHeight="getRowHeight"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :floatingFilter="true"
          :rowData="productStockList"
          :isFullWidthCell="isFullWidthCell"
          :fullWidthCellRenderer="fullWidthCellRenderer"
          id="myGrid"
          :pagination="true"
          :paginationPageSize="20"
          @gridSizeChanged="onGridSizeChanged"
          @grid-ready="onGridReady"
        ></ag-grid-vue>
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
        <div class="vx-row justify-end flex">
          <div class="vx-col">
            <vs-button size="small" type="border" @click="clearAllSelectedProducts()">Seçilenleri Temizle</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="border" @click="selectDisplayedProducts()">Ekrandakileri Seç</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="border" @click="selectFilteredProducts()">Filtrelenenleri Seç</vs-button>
          </div>
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>

      <!--***************************************** tab 2 content****************************************************** -->
      <tab-content title="Üretim Reçetesi" icon="feather icon-sliders" :before-change="beforeChangeForTab2">
        <div v-if="selectedRows.length > 0">
          <div class="vx-row w-full" style="align-items: center;">
            <div class="vx-col md:w-1/2">
              <span class="mr-5"> Üretilen Ürün :</span> <b class="mr-5"> {{ selectedRows[0].productName }} </b> Ürününün Üretim Süreci
            </div>
            <div class="vx-col flex w-full md:w-1/2">
              <feather-icon class="mr-5" icon="MinusSquareIcon" svgClasses="hover:text-primary cursor-pointer" @click="CalcuteProduceAmount('Subtract')" />
              <vs-input type="number" v-model="selectedRows[0].productionAmount" style="width:99px" @input="CalcuteProduceAmount()" />
              <feather-icon icon="PlusSquareIcon" class="ml-5" svgClasses="hover:text-primary cursor-pointer" @click="CalcuteProduceAmount('Add')" />
            </div>
          </div>

          <div class="vx-row flex mt-10">
            <div class="vx-col flex items-center" style="width: 30%;">
              Materyal Adı
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Reçete Miktar
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Kullanılacak Miktar
            </div>

            <div class="vx-col flex items-center" style="width: 10%;">
              Stok
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Kalan Stok
            </div>
            <div class="vx-col flex items-center" style="width: 10%;">
              Miktar Türü
            </div>
          </div>

          <div v-if="selectedRows.length > 0" class="mb-12">
            <div v-for="(tr, i) in selectedRows[0].produceList" :key="i" class="vx-row flex mt-10">
              <div style="width: 30%;" class="vx-col flex items-center">
                {{ tr.productName }}
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input type="number" v-model="tr.produceAmount" readonly="true" />
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input type="number" v-model="tr.produceReceiptAmount" readonly="true" />
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input type="number" v-model="tr.stock" readonly="true" />
              </div>
              <div style="width: 10%;" class="vx-col flex items-center">
                <vs-input type="number" v-model="tr.remainedStock" readonly="true" />
              </div>

              <div style="width: 10%;" class="vx-col flex items-center">
                <v-select disabled name="amountTypeSelection" v-model="tr.amountTypeId" placeholder="Miktar Tür" :options="productAmountTypeList" label="productAmountTypeName" class="select" :reduce="(amount) => amount.productAmountTypeId">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row justify-between flex mt-2">
          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
          </div>

          <div class="vx-col">
            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" @click="$refs.formWizard.nextTab()">İleri</vs-button>
          </div>
        </div>
      </tab-content>

      <!-- ****************************************tab 3 content ********************************************************-->
      <tab-content title="Onayla" class="mb-5" icon="feather icon-check-circle" :on-complete="formSubmitted">
        <template v-if="selectedRows.length > 0">
          <div class="flex items-end items-center px-3">
            <feather-icon svgClasses="w-6 h-6" icon="EyeIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Değişen Değerler</span>
          </div>
          <vs-table search noDataText="Ürün Bulunamadı!" :data="selectedRows[0].produceList" maxHeight="280px" class="px-2">
            <template slot="header">
              <span class="mr-5"> Üretilen Ürün :</span> <b class="mr-5"> {{ selectedRows[0].productName }} </b> Ürününün Üretim Süreci
            </template>

            <template slot="thead">
              <vs-th>Materyal Adı</vs-th>
              <vs-th>Reçete Miktarı</vs-th>
              <vs-th>Kullanılacak Miktar</vs-th>
              <vs-th>Stok</vs-th>
              <vs-th>Miktar Türü</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(tr, i) in data" :key="i">
                <vs-td style="width: 30%;">{{ tr.productName }}</vs-td>
                <vs-td style="width: 15%;">{{ tr.produceAmount }}</vs-td>
                <vs-td style="width: 15%;">{{ tr.produceReceiptAmount }}</vs-td>
                <vs-td style="width: 10%;">{{ tr.stock }}</vs-td>
                <vs-td style="width: 10%;">
                  <v-select disabled name="amountTypeSelection" v-model="tr.amountTypeId" placeholder="Miktar Tür" :options="productAmountTypeList" label="amountTypeName" class="select" :reduce="(amount) => amount.amountTypeId">
                    <span slot="no-options">Eşleşen Veri Yok</span>
                  </v-select>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="vx-row justify-between flex mt-2">
            <div class="vx-col">
              <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-left" @click="$refs.formWizard.prevTab()">Geri</vs-button>
            </div>

            <div class="vx-col">
              <vs-button size="small" type="filled" icon-pack="feather" icon="icon-chevron-right" v-if="purchaseList[0].purchaseStatus == 'T'" @click.native="formSubmitted">Kaydet</vs-button>
            </div>
          </div>
        </template>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import { repository } from "@/_services/repository.js";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";

const AG_GRID_LOCALE_TR = {
  equals: "Eşittir",
  notEqual: "Eşit Değildir",
  lessThan: "Daha Az",
  lessThanOrEqual: "Az veya Eşit",
  greaterThan: "Büyüktür",
  greaterThanOrEqual: "Büyük veya Eşit",
  inRange: "İçinde",

  contains: "İçerir",
  notContains: "İçermez",
  startsWith: "İle Başlar",
  endsWith: "İle Biter",

  andCondition: "ve",
  orCondition: "veya",

  filterOoo: "Filtre",

  to: "-",
  of: " / ",
  page: "Sayfa",
};

export default {
  components: {
    FormWizard,
    TabContent,
    vSelect,
    AgGridVue,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      maxPageNumbers: 8,
      gridOptions: {
        // onFilterChanged: function (ev) {
        //   console.log(ev.api.rowModel.rowsToDisplay);
        // },
      },
      productionId: undefined,
      operation: "SaveProduction",
      searchName: undefined,
      supplierList: [],
      currencyList: [],
      warehouseList: [],
      productAmountTypeList: [],
      supplierPageNumber: 1,
      gridApi: null,
      columnApi: null,
      isFullWidthCell: null,
      fullWidthCellRenderer: null,
      getRowHeight: null,
      selectedRows: [],
      columnDefs: [
        {
          headerName: "Ürün Adı",
          field: "productName",
          filter: true,
          editable: false,
          checkboxSelection: true,
          width: 300,
        },
        {
          headerName: "Marka",
          field: "brand",
          filter: true,
          width: 100,
        },

        {
          headerName: "ProductId",
          field: "productId",
          filter: true,
          width: 150,
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        //editable: true
      },

      purchaseList: [{ purchaseStatus: "T" }],
      productStockList: [],
      loading: true,
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload();
      }
    },
  },
  created() {
    //Güncelleme için URL den pruchaseId çekiliyor
    if (this.$route.params != null && this.$route.params.productionId > 0) {
      this.productionId = this.$route.params.productionId;
      this.getProductionById();
    }

    Promise.all([this.GetProductForProduction(), this.getProductAmountType()]);
  },
  beforeMount() {
    this.localeText = AG_GRID_LOCALE_TR;
    this.getRowHeight = (params) => {
      if (params.data.header) {
        return 50;
      } else return 40;
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridApi.sizeColumnsToFit();

    document.getElementsByClassName("wizard-header")[0].style.display = "none";
    document.getElementsByClassName("wizard-card-footer")[0].style.display = "none";
    window.ab = this.$refs.formWizard;
  },

  computed: {
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },

  methods: {
    CalcuteProduceAmount: async function(operation) {
      if (operation == "Subtract" && this.selectedRows[0].productionAmount - 1 < 1) {
        await this.$swal.fire({
          icon: "warning",
          title: "Üretim Miktarı 1 den küçük olamaz",
          //text: messageText,
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });
        return;
      } else if (operation == "Subtract") {
        
        this.selectedRows[0].productionAmount = Number.parseInt(this.selectedRows[0].productionAmount) - 1;
      } else if (operation == "Add") {
        this.selectedRows[0].productionAmount = Number.parseInt(this.selectedRows[0].productionAmount) + 1;
      }

      this.selectedRows[0].produceList.forEach((p) => {
        p.produceReceiptAmount = (this.selectedRows[0].productionAmount * p.produceAmount).toFixed(2);
        p.remainedStock = p.stock - p.produceReceiptAmount;
      });
    },

    getProductionById: async function() {
      let result = await repository.getById("Production/getProductionById" + "/" + this.productionId, this.productionId);
      this.purchaseList = result.list;
      result.list.forEach((row) => {
        this.gridApi.forEachNode((node) => {
          if (node.data.productId === row.purchaseProductId) {
            node.data.purchaseAmount = row.purchaseAmount;
            node.data.purchaseAmountTypeName = row.purchaseAmountTypeName;
            node.data.purchaseAmountTypeId = row.purchaseAmountTypeId;

            node.data.purchaseCurrency = row.purchaseCurrency;
            node.data.purchaseCurrencyId = row.purchaseCurrencyId;
            node.data.purchaseCurrencyName = row.purchaseCurrencyName;

            node.data.purchaseFxRate = row.purchaseFxRate;
            node.data.purchaseUnitPrice = row.purchaseUnitPrice;

            node.data.purchaseSupplierName = row.purchaseSupplierName;
            node.data.purchaseSupplierId = row.purchaseSupplierId;

            node.data.purchaseWarehouseId = row.purchaseWarehouseId;
            node.data.purchaseWarehouseName = row.purchaseWarehouseName;

            node.setSelected(true);
          }
        });
      });
    },

    formWizardPageChanged: async function(prevIndex, nextIndex) {},
    onGridSizeChanged() {
      // this.gridApi.sizeColumnsToFit();
    },
    onGridReady() {
      //this.gridApi.sizeColumnsToFit();
    },

    GetProductForProduction: async function() {
      this.productStockList = await repository.postEntity("Production/GetProductForProduction", { produceType: "Produce" }).then((r) => r.list);
    },

    getProductionReceiptList: async function() {
      this.productStockList = await repository.postEntity("Product/GetProductDetail", { produceProductId: this.productId }).then((r) => r.list);
    },

    getProductAmountType: async function() {
      this.productAmountTypeList = await repository.getAll("Purchase/getProductAmountType").then((r) => r.list);
    },

    formSubmitted: async function() {
      let strHtmlProduce = "";
      //this.selectedRows[0].produceList.forEach((r) => (strHtmlProduce += r.productName + " ( " + r.produceReceiptAmount + " Adet )" + "<br/>"));

      let resultConfirmForOverwrite = await this.$swal.fire({
        icon: "warning",
        title: "Üretim süreci başlatılacaktır emin misiniz?",
        //text: "Üretim Özeti",
        //input: "text",
        html:
          "<div style='text-align: center;'><b>Üretim Özeti</b><br/></div> " +
          "<b>Üretilecek Ürün : </b>" +
          this.selectedRows[0].productName +
          " ( " +
          this.selectedRows[0].productionAmount +
          " Adet )" +
          // "<br/><div style='text-align: center;'><b>Reçete Bilgisi</b></div>" +
          strHtmlProduce,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (resultConfirmForOverwrite.isConfirmed) null;
      else return;
      this.selectedRows[0].operation = this.operation;
      await repository.postEntity("Production/saveProduction", this.selectedRows[0]);

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı.",
        //text: "İşlem Başarılı.",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      });
      this.$router.push({ path: "ProductionList" });
    },

    //aktif olan sayfada gördüklerimizi seçmek için
    selectDisplayedProducts() {
      let urunler = this.gridApi.getRenderedNodes();
      for (let a = 0; a < urunler.length; a++) this.gridApi.getRowNode(urunler[a].id).setSelected(true);
    },

    //Filtrelenen ürünlerin seçilmesi için
    selectFilteredProducts() {
      let filtered = this.gridApi.rowModel.rowsToDisplay;
      for (let i = 0; i < filtered.length; i++) {
        this.gridApi.getRowNode(filtered[i].id).setSelected(true);
      }
    },

    beforeChangeForTab2: async function() {
      let validationResult = true;

      let negativeList = this.selectedRows[0].produceList.every((p) => p.remainedStock >= 0);

      if (negativeList == false) {
        await this.$swal.fire({
          icon: "warning",
          title: "Yetersiz stok?",
          text: "Üretim hammadde stoğu yetersiz olduğu için üretim yapılamaz.",
          //input: "text",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tamam",
          cancelButtonText: "Hayır",
        });
        validationResult = false;
      }

      return validationResult;
    },

    validateAsync() {
      this.selectedRows = []; //ileri geri yaptığımızda sürekli ekleme yapıyordu. Bu sebeple öncesinde sıfırlıyoruz
      this.gridApi.getSelectedRows().forEach((rows) => this.selectedRows.push(rows));

      console.log(this.selectedRows);
      return true;
    },
  },
};
</script>

<style lang="scss">
.select {
  width: 75px;
  display: inline-block;
  margin-left: 10px;
  .vs__actions {
    display: none;
  }
}
</style>
